// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  shipment: icon('ic_shipment'),
  storage: icon('ic_storage'),
  dictionary: icon('ic_dictionary'),
  admin: icon('ic_admin'),
  transactions: icon('ic_transactions'),
  sales: icon('ic_sales'),
  web: icon('ic_web'),
  procurement: icon('ic_invoice')
};

/** Permission key from RESOLVERS — required to show menu item. Main has no permission (always shown). */
const navConfig = [
  {
    subheader: 'general',
    items: [
      { title: 'Main', path: PATH_DASHBOARD.general.app, icon: ICONS.dashboard },
      { title: 'Sales', path: PATH_DASHBOARD.sales.scroller, icon: ICONS.sales, permission: 'sales' },
      { title: 'Storage Docs', path: PATH_DASHBOARD.storageDocuments.scroller, icon: ICONS.storage, permission: 'storageDocuments' },
      { title: 'Transactions', path: PATH_DASHBOARD.transactions.scroller, icon: ICONS.transactions, permission: 'transactions' },
      { title: 'Shipments', path: PATH_DASHBOARD.storageShipments.scroller, icon: ICONS.shipment, permission: 'storageShipments' },
      {
        title: 'Dictionaries',
        path: PATH_DASHBOARD.dictionaries.root,
        icon: ICONS.dictionary,
        children: [
          { title: 'Products', path: PATH_DASHBOARD.dictionaries.product.scroller, permission: 'product' },
          { title: 'Categories', path: PATH_DASHBOARD.dictionaries.category.scroller, permission: 'productCategory' },
          { title: 'Brands', path: PATH_DASHBOARD.dictionaries.brand.scroller, permission: 'productBrand' },
          { title: 'Storages', path: PATH_DASHBOARD.dictionaries.storages.scroller, permission: 'storage' },
          { title: 'Accounts', path: PATH_DASHBOARD.dictionaries.accounts.scroller, permission: 'account' },
          { title: 'Transaction Articles', path: PATH_DASHBOARD.dictionaries.transactionArticles.scroller, permission: 'transactionArticles' },
          { title: 'Source Orders', path: PATH_DASHBOARD.dictionaries.sourceOrders.scroller, permission: 'sourceOrders' },
          { title: 'Delivery Services', path: PATH_DASHBOARD.dictionaries.deliveryServices.scroller, permission: 'deliveryServices' },
          { title: 'Document Templates', path: PATH_DASHBOARD.dictionaries.documentTemplates.scroller, permission: 'documentTemplates' },
        ],
      },
    ],
  },
  {
    subheader: 'modules',
    items: [
      { title: 'Price monitoring', path: PATH_DASHBOARD.general.checkPrice.scroller, icon: ICONS.analytics, permission: 'checkPriceMonitor' },
      { title: 'Sites', path: PATH_DASHBOARD.general.sites.scroller, icon: ICONS.web, permission: 'sitesScroller' },
      {
        title: 'Ozon',
        path: PATH_DASHBOARD.ozon.postings.scroller,
        icon: ICONS.ecommerce,
        children: [
          { title: 'Orders', path: PATH_DASHBOARD.ozon.postings.scroller, permission: 'ozonPostings' },
          { title: 'Seller accounts', path: PATH_DASHBOARD.ozon.sellerAccounts.scroller, permission: 'ozonSellerAccounts' },
        ],
      },
      {
        title: 'WB',
        path: PATH_DASHBOARD.wb.postings.scroller,
        icon: ICONS.ecommerce,
        children: [
          { title: 'Orders', path: PATH_DASHBOARD.wb.postings.scroller, permission: 'wbPostings' },
          { title: 'Catalog products', path: PATH_DASHBOARD.wb.catalogProducts.scroller, permission: 'wbCatalogProducts' },
          { title: 'Seller accounts', path: PATH_DASHBOARD.wb.sellerAccounts.scroller, permission: 'wbSellerAccounts' },
        ],
      },
      {
        title: 'Avito',
        path: PATH_DASHBOARD.avito.postings.scroller,
        icon: ICONS.ecommerce,
        children: [
          { title: 'Orders', path: PATH_DASHBOARD.avito.postings.scroller, permission: 'avitoPostings' },
          { title: 'Seller accounts', path: PATH_DASHBOARD.avito.sellerAccounts.scroller, permission: 'avitoSellerAccounts' },
        ],
      },
      {
        title: 'Procurement',
        path: PATH_DASHBOARD.procurement.suppliers.scroller,
        icon: ICONS.procurement,
        children: [
          { title: 'Suppliers', path: PATH_DASHBOARD.procurement.suppliers.scroller, permission: 'procurementSuppliers' },
          { title: 'Contracts', path: PATH_DASHBOARD.procurement.contracts.scroller, permission: 'procurementContracts' },
          { title: 'Requests', path: PATH_DASHBOARD.procurement.requests.scroller, permission: 'procurementRequests' },
          { title: 'Deliveries', path: PATH_DASHBOARD.procurement.deliveries.scroller, permission: 'procurementDeliveries' },
        ],
      },
    ],
  },
  {
    subheader: 'settings',
    items: [
      {
        title: 'administration',
        path: PATH_DASHBOARD.administration.root,
        icon: ICONS.admin,
        children: [
          { title: 'groups', path: PATH_DASHBOARD.administration.groups.scroller, permission: 'groups' },
          { title: 'languages', path: PATH_DASHBOARD.administration.i18nLang.scroller, permission: 'i18nLang' },
          { title: 'translations', path: PATH_DASHBOARD.administration.i18nKeys.scroller, permission: 'i18nKey' },
          { title: 'user', path: PATH_DASHBOARD.administration.user.scroller, permission: 'user' },
        ],
      },
    ],
  },
];

export type NavConfig = typeof navConfig

export default navConfig;
